import { Entity, Field } from '@adornis/baseql/decorators.js';
import { ProductFilter } from '@adornis/buchungsheld-db/entities/products.js';
import { HTMLBase } from '@adornis/html-based-buildify/db/HTMLBase.js';
@Entity()
export class HTMLBaseInstitutionProducts extends HTMLBase {
  static override _class = 'HTMLBaseInstitutionProducts';

  @Field(type => ProductFilter, { default: v => v ?? new ProductFilter({}) }) filter!: ProductFilter;
}
